import { forwardRef } from "react";
import Button, { ButtonProps } from "../button";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";

export interface PaginationItemProps extends Omit<ButtonProps, "variant"> {
  active?: boolean;
}

const PaginationItem = forwardRef<HTMLButtonElement, PaginationItemProps>(
  (props, ref) => {
    const { className, active, ...rest } = props;
    return (
      <Button
        {...rest}
        ref={ref}
        className={twMerge(
          clsx(
            "enabled:shadow-none enabled:hover:shadow-none rounded-none h-full",
            {
              "enabled:bg-white": !active,
            }
          ),
          className
        )}
        variant={active ? "primary" : "light"}
      />
    );
  }
);

export default PaginationItem;

function createButton(
  name: string,
  defaultValue: React.ReactNode,
  label: string = name
) {
  const Button = forwardRef<HTMLButtonElement, PaginationItemProps>(
    (props, ref) => {
      const { children, ...rest } = props;
      return (
        <PaginationItem {...rest} ref={ref}>
          <span aria-hidden="true">{children || defaultValue}</span>
          <span className="hidden">{label}</span>
        </PaginationItem>
      );
    }
  );

  Button.displayName = name;
  return Button;
}

export const First = createButton("First", "«");
export const Prev = createButton("Prev", "‹", "Previous");
export const Ellipsis = createButton("Ellipsis", "…", "More");
export const Next = createButton("Next", "›");
export const Last = createButton("Last", "»");
